import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "border-t border-slate-200 bg-white flex-shrink-0"
};
const _hoisted_2 = {
  key: 0,
  class: "px-4 pt-2 flex items-center gap-2"
};
const _hoisted_3 = {
  class: "flex-1 flex items-center gap-2 px-3 py-1.5 bg-slate-50 rounded-lg border-l-2 border-l-primary-400"
};
const _hoisted_4 = {
  class: "flex-1 min-w-0"
};
const _hoisted_5 = {
  class: "text-[11px] text-primary-600 font-medium"
};
const _hoisted_6 = {
  class: "text-xs text-slate-500 truncate"
};
const _hoisted_7 = {
  class: "flex items-center gap-1 px-4 pt-2"
};
const _hoisted_8 = {
  key: 0,
  class: "absolute bottom-10 left-0 z-50"
};
const _hoisted_9 = {
  class: "p-3 pt-1"
};
const _hoisted_10 = {
  class: "flex items-end gap-2"
};
const _hoisted_11 = ["onKeydown"];
const _hoisted_12 = ["disabled"];
import { ref, nextTick, onMounted, onUnmounted } from 'vue';
import { useChatStore } from '@/stores/chat';
import EmojiPicker from './EmojiPicker.vue';
export default {
  __name: 'ChatInput',
  emits: ['send', 'sendFile', 'sendImage'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const chatStore = useChatStore();
    const inputText = ref('');
    const inputRef = ref(null);
    const fileInput = ref(null);
    const imageInput = ref(null);
    const showEmojiPicker = ref(false);
    const emojiRef = ref(null);
    function handleSend() {
      if (!inputText.value.trim()) return;
      emit('send', inputText.value);
      inputText.value = '';
      nextTick(() => {
        if (inputRef.value) {
          inputRef.value.style.height = 'auto';
        }
      });
    }
    function handleNewLine() {
      // Shift+Enter 换行 - 默认行为
    }
    function autoResize() {
      const el = inputRef.value;
      if (el) {
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 128) + 'px';
      }
    }
    function handleEmojiSelect(emoji) {
      inputText.value += emoji;
      showEmojiPicker.value = false;
      inputRef.value?.focus();
    }
    function handleFileSelect(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      const fileSizeStr = file.size < 1024 * 1024 ? (file.size / 1024).toFixed(0) + 'KB' : (file.size / (1024 * 1024)).toFixed(1) + 'MB';
      emit('sendFile', {
        fileName: file.name,
        fileSize: fileSizeStr,
        file
      });

      // 重置 input 允许重复选择同文件
      event.target.value = '';
    }
    function handleImageSelect(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        emit('sendImage', {
          imageUrl: e.target.result,
          fileName: file.name,
          file
        });
      };
      reader.readAsDataURL(file);
      event.target.value = '';
    }

    // 点击外部关闭 emoji
    function handleClickOutside(e) {
      if (emojiRef.value && !emojiRef.value.contains(e.target)) {
        showEmojiPicker.value = false;
      }
    }
    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    // 外部聚焦方法
    function focus() {
      inputRef.value?.focus();
    }
    __expose({
      focus
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(chatStore).replyToMessage ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(_unref(chatStore).replyToMessage.senderName), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(chatStore).replyToMessage.content || _unref(chatStore).replyToMessage.fileName || '[文件]'), 1)]), _createElementVNode("button", {
        class: "p-0.5 text-slate-400 hover:text-slate-600 rounded transition-colors cursor-pointer flex-shrink-0",
        onClick: _cache[0] || (_cache[0] = $event => _unref(chatStore).clearReplyTo())
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "relative",
        ref_key: "emojiRef",
        ref: emojiRef
      }, [_createElementVNode("button", {
        class: _normalizeClass(["p-1.5 rounded-lg transition-colors cursor-pointer", showEmojiPicker.value ? 'text-primary-500 bg-primary-50' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100']),
        title: "表情",
        onClick: _cache[1] || (_cache[1] = $event => showEmojiPicker.value = !showEmojiPicker.value)
      }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      })], -1)]))], 2), showEmojiPicker.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(EmojiPicker, {
        onSelect: handleEmojiSelect
      })])) : _createCommentVNode("", true)], 512), _createElementVNode("button", {
        class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer",
        title: "发送文件",
        onClick: _cache[2] || (_cache[2] = $event => fileInput.value?.click())
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
      })], -1)]))]), _createElementVNode("input", {
        ref_key: "fileInput",
        ref: fileInput,
        type: "file",
        class: "hidden",
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt",
        onChange: handleFileSelect
      }, null, 544), _createElementVNode("button", {
        class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer",
        title: "发送图片",
        onClick: _cache[3] || (_cache[3] = $event => imageInput.value?.click())
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      })], -1)]))]), _createElementVNode("input", {
        ref_key: "imageInput",
        ref: imageInput,
        type: "file",
        accept: "image/*",
        class: "hidden",
        onChange: handleImageSelect
      }, null, 544)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("textarea", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => inputText.value = $event),
        placeholder: "输入消息... (Enter发送, Shift+Enter换行)",
        rows: "1",
        class: "flex-1 resize-none text-sm text-slate-700 bg-transparent border-none outline-none leading-relaxed max-h-32 placeholder:text-slate-400",
        onKeydown: [_withKeys(_withModifiers(handleSend, ["exact", "prevent"]), ["enter"]), _withKeys(_withModifiers(handleNewLine, ["shift", "exact"]), ["enter"])],
        onInput: autoResize,
        onFocus: _cache[5] || (_cache[5] = $event => showEmojiPicker.value = false)
      }, null, 40, _hoisted_11), [[_vModelText, inputText.value]]), _createElementVNode("button", {
        class: _normalizeClass(["p-2 rounded-lg transition-colors flex-shrink-0 cursor-pointer", inputText.value.trim() ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-slate-100 text-slate-400 cursor-not-allowed']),
        disabled: !inputText.value.trim(),
        onClick: handleSend
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
      })], -1)]))], 10, _hoisted_12)])])]);
    };
  }
};